@if (suppliedGridQueryData && TooltipMap) {
  <div class="container-fluid h-75">
    <div class="row row-padding">
      <div class="col">
        <label class="title-label">{{ title }}</label>
      </div>
    </div>
    @if (LoggedInUser.UserAccountType!.name === 'Client' && ProposalRequest) {
      <div class="row row-padding">
        <div class="col"></div>
        @if (areReportsVisible(ProposalRequest)) {
          <div class="col-4">
            <button
              class="btn btn-primary"
              (click)="generateComprehensiveBidReport()"
            >
              Comprehensive report
            </button>
          </div>
        }
        @if (areReportsVisible(ProposalRequest)) {
          <div class="col-4">
            <button
              class="btn btn-primary"
              (click)="generateBidComparisonReport()"
            >
              Comparison report
            </button>
          </div>
        }
        @if (isProposalRequestNotInTerminalStatus(ProposalRequest)) {
          <div class="col-auto">
            <button class="btn btn-primary" (click)="closeProposalRequest()">
              Close proposal to new bids
            </button>
          </div>
        }
      </div>
    }
    <div class="row grid-container">
      <app-proposal-request-vendors-grid
        [gridName]="'VendorProposalRequestVendors'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [suppliedQueryData]="suppliedGridQueryData"
        [getCalculatedColumnActions]="getDisplayedColumnActions"
        [(reloadGridData)]="reloadGrid"
        [TooltipMap]="TooltipMap"
        (actionEvent)="action($event)"
      ></app-proposal-request-vendors-grid>
    </div>
    @if (LoggedInUser.UserAccountType!.name === 'Client') {
      <div class="row row-padding">
        <div class="offset-8 col-4">
          <button class="btn btn-primary" (click)="goToProposalRequestsGrid()">
            Back
          </button>
        </div>
      </div>
    }
  </div>
}
